import { render } from "./ResultRecommendItem.vue?vue&type=template&id=4900c450&scoped=true"
import script from "./ResultRecommendItem.vue?vue&type=script&lang=js"
export * from "./ResultRecommendItem.vue?vue&type=script&lang=js"

import "./ResultRecommendItem.vue?vue&type=style&index=0&id=4900c450&lang=scss&scoped=true"

import exportComponent from "/Users/konatsu/docker-static/speedo.devs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4900c450"]])

export default __exports__